class MessageService {
  constructor() {
    this.messages = [];
    this.subscribers = []; // Массив подписчиков
  }

  // Метод для подписки на изменения
  subscribe(callback) {
    this.subscribers.push(callback);
    // Возвращаем функцию для отписки
    return () => {
      this.subscribers = this.subscribers.filter((sub) => sub !== callback);
    };
  }

  // Уведомляем всех подписчиков об изменениях
  notifySubscribers() {
    this.subscribers.forEach((callback) => {
      callback([...this.messages]); // Передаем копию массива
    });
  }

  addMessage(mess, delay = 3500) {
    this.messages.push(mess);
    this.notifySubscribers(); // Уведомляем при добавлении

    setTimeout(() => {
      this.messages.splice(0, 1);
      this.notifySubscribers(); // Уведомляем при удалении
    }, delay);
  }

  addErrorMessage(text, delay = 3500) {
    const message = { text, background: "rgba(255, 30, 0, 0.6)" };
    this.addMessage(message, delay);
  }

  addWarningMessage(text, delay = 2500) {
    const message = { text, background: "rgba(76, 76, 76, 0.6)" };
    this.addMessage(message, delay);
  }

  addSuccessMessage(text, delay = 3500) {
    const message = { text, background: "rgba(35, 151, 0, 0.6)" };
    this.addMessage(message, delay);
  }

  addInfoMessage(text, delay = 3500) {
    const message = { text, background: "rgba(255, 110, 0, 0.6)" };
    this.addMessage(message, delay);
  }

  getMessages() {
    return this.messages;
  }
}

// Экспортируем единственный экземпляр
const messageServiceInstance = new MessageService();
export default messageServiceInstance;
